import { ID } from '../definitions/types';

export interface GeneralValidationResult {
    errors: TreeValidationError[];
}

export interface TreeValidationError {
    nodeId: ID;
    fieldId: ID;
    errorType: ErrorType;
    errorMessage: string;
}

export interface Errors {
    errors: TreeValidationError[];
    warnings: TreeValidationError[];
}

export enum ErrorType {
    UNKNOWN,
    MISSING_IDS,
    CIRCULAR_REFERENCE,
    INFINITE_LOOP,
    MISSING_CORRESPONDING_GOTO,
    LINK_NOT_FOUND,
    TARGET_NOT_FOUND,
    ENTITY_NOT_FOUND,
    INCONSISTENT_PATTERN,
    NO_DATA_GENERATED,
    MISSING_PROPERTY,
    // Expression errors are a frontend only error type
    // used when we merge all the errors in the same place
    EXPRESSION_ERROR
}

export type TreeValidationState = {
    nodeErrors: { [nodeId: ID]: NodeErrors };
    globalErrors: Errors;
    validationErrors: TreeValidationError[];
};

export type FieldErrors = { [fieldId: ID]: Errors };

export type NodeErrors = {
    fieldErrors: FieldErrors;
    nodeErrors: Errors;
};

export function adaptToState(result: GeneralValidationResult): TreeValidationState {
    const state: TreeValidationState = {
        nodeErrors: {},
        globalErrors: {
            errors: [],
            warnings: []
        },
        validationErrors: []
    };

    function initializeFieldErrors(nodeId: ID, fieldId: ID) {
        state.nodeErrors[nodeId].fieldErrors[fieldId] = {
            errors: [],
            warnings: []
        };
    }

    function initializeNodeErrors(nodeId: ID) {
        state.nodeErrors[nodeId] = {
            nodeErrors: {
                errors: [],
                warnings: []
            } as Errors,
            fieldErrors: {} as FieldErrors
        } as NodeErrors;
    }
    result.errors.forEach((error) => {
        const { nodeId, fieldId, errorMessage, errorType } = error;
        if (!nodeId) {
            state.globalErrors.errors.push(error);
        } else {
            if (!state.nodeErrors[nodeId]) {
                initializeNodeErrors(nodeId);
            }
            if (!fieldId) {
                state.nodeErrors[nodeId].nodeErrors.errors.push(error);
            } else {
                if (!state.nodeErrors[nodeId].fieldErrors[fieldId]) {
                    initializeFieldErrors(nodeId, fieldId);
                }
                state.nodeErrors[nodeId].fieldErrors[fieldId].errors.push(error);
            }
        }
    });
    return state;
}
